import { BATTLESHIP, CALYPSO, CALYPSO_LIGHT, HEFFALUMP, KOALA, LORAX, LORAX_LIGHT, MARIGOLD_DARK, MARIGOLD_LIGHT, NORMAN, NORMAN_LIGHT, OLAF, OZ, OZ_LIGHT, SLINKY, THUNDERDOME, THUNDERDOME_LIGHT } from 'HubStyleTokens/colors';
import { MAGENTA } from 'ai-components-ui-library/styles/colors';
import { Record } from 'immutable';
const ActionTheme = Record({
  accentColor: null,
  backgroundColorName: null,
  // No longer used?
  color: null,
  // Not sure where this is used?
  headerBackgroundColor: null,
  iconColor: null
}, 'ActionTheme');
export const battleshipTheme = new ActionTheme({
  accentColor: BATTLESHIP,
  backgroundColorName: 'olaf',
  color: BATTLESHIP,
  headerBackgroundColor: OLAF,
  iconColor: BATTLESHIP
});
const breezeTheme = new ActionTheme({
  accentColor: MAGENTA[400],
  headerBackgroundColor: MAGENTA[100],
  iconColor: MAGENTA[400]
});
export const calypsoTheme = new ActionTheme({
  accentColor: CALYPSO,
  backgroundColorName: 'calypso',
  color: HEFFALUMP,
  headerBackgroundColor: CALYPSO_LIGHT,
  iconColor: CALYPSO
});
export const defaultTheme = new ActionTheme({
  accentColor: null,
  backgroundColorName: 'heffalump',
  color: SLINKY,
  headerBackgroundColor: KOALA,
  iconColor: SLINKY
});
export const koalaTheme = new ActionTheme({
  accentColor: SLINKY,
  backgroundColorName: 'koala',
  color: SLINKY,
  headerBackgroundColor: KOALA,
  iconColor: SLINKY
});
export const marigoldTheme = new ActionTheme({
  accentColor: MARIGOLD_DARK,
  backgroundColorName: 'marigold',
  color: HEFFALUMP,
  headerBackgroundColor: MARIGOLD_LIGHT,
  iconColor: MARIGOLD_DARK
});
export const normanTheme = new ActionTheme({
  accentColor: NORMAN,
  backgroundColorName: 'norman',
  color: HEFFALUMP,
  headerBackgroundColor: NORMAN_LIGHT,
  iconColor: NORMAN
});
export const ozTheme = new ActionTheme({
  accentColor: OZ,
  backgroundColorName: 'oz',
  color: HEFFALUMP,
  headerBackgroundColor: OZ_LIGHT,
  iconColor: OZ
});

// UIBuilderCard doesn't support 'lorax', sorbet is the closest color
export const sorbetTheme = new ActionTheme({
  accentColor: LORAX,
  backgroundColorName: 'sorbet',
  color: HEFFALUMP,
  headerBackgroundColor: LORAX_LIGHT,
  iconColor: LORAX
});
export const thunderdomeTheme = new ActionTheme({
  accentColor: THUNDERDOME,
  backgroundColorName: 'thunderdome',
  color: HEFFALUMP,
  headerBackgroundColor: THUNDERDOME_LIGHT,
  iconColor: THUNDERDOME
});
export default {
  battleship: battleshipTheme,
  breeze: breezeTheme,
  calypso: calypsoTheme,
  default: defaultTheme,
  heffalump: defaultTheme,
  koala: koalaTheme,
  marigold: marigoldTheme,
  norman: normanTheme,
  oz: ozTheme,
  sorbet: sorbetTheme,
  thunderdome: thunderdomeTheme
};